import { createIcon } from '@chakra-ui/react';
import colors from 'src/theme/colors';

export default createIcon({
  displayName: 'QuoteIcon',
  viewBox: '0 0 96 18',
  path: [
    <path key="a" d="M18 0H0V18H18V0Z" fill={colors.AlituGreen} />,
    <path key="b" d="M37.5 0H19.5V18H37.5V0Z" fill={colors.AlituGreen} />,
    <path key="c" d="M57 0H39V18H57V0Z" fill={colors.AlituGreen} />,
    <path key="d" d="M76.5 0H58.5V18H76.5V0Z" fill={colors.AlituGreen} />,
    <path key="e" d="M96 0H87V18H96V0Z" fill={colors.podcastShade300} />,
    <path key="f" d="M96 0H78V18H96V0Z" fill={colors.AlituGreen} />,
    <path
      key="g"
      d="M9.00007 12.1313L11.7376 11.4375L12.8813 14.9625L9.00007 12.1313ZM15.3001 7.57504H10.4813L9.00007 3.03754L7.51882 7.57504H2.70007L6.60007 10.3875L5.11882 14.925L9.01882 12.1125L11.4188 10.3875L15.3001 7.57504Z"
      fill="white"
    />,
    <path
      key="h"
      d="M28.5001 12.1313L31.2376 11.4375L32.3813 14.9625L28.5001 12.1313ZM34.8001 7.57504H29.9813L28.5001 3.03754L27.0188 7.57504H22.2001L26.1001 10.3875L24.6188 14.925L28.5188 12.1125L30.9188 10.3875L34.8001 7.57504Z"
      fill="white"
    />,
    <path
      key="i"
      d="M48.0001 12.1313L50.7376 11.4375L51.8813 14.9625L48.0001 12.1313ZM54.3001 7.57504H49.4813L48.0001 3.03754L46.5188 7.57504H41.7001L45.6001 10.3875L44.1188 14.925L48.0188 12.1125L50.4188 10.3875L54.3001 7.57504Z"
      fill="white"
    />,
    <path
      key="j"
      d="M67.5001 12.1313L70.2376 11.4375L71.3813 14.9625L67.5001 12.1313ZM73.8001 7.57504H68.9813L67.5001 3.03754L66.0188 7.57504H61.2001L65.1001 10.3875L63.6188 14.925L67.5188 12.1125L69.9188 10.3875L73.8001 7.57504Z"
      fill="white"
    />,
    <path
      key="k"
      d="M87.0001 12.1313L89.7376 11.4375L90.8813 14.9625L87.0001 12.1313ZM93.3001 7.57504H88.4813L87.0001 3.03754L85.5188 7.57504H80.7001L84.6001 10.3875L83.1188 14.925L87.0188 12.1125L89.4188 10.3875L93.3001 7.57504Z"
      fill="white"
    />,
  ],
});
